import { combineReducers } from 'redux';

// Main API reducer.
import { createReducer } from '@exonet/jsonapi-fetcher';

// Local reducers.
import appReducer, { constants as appConstants } from './app';
import otpReducer from './otp';
import userReducer from './user';
import socketReducer from './socket';
import userConstants from './user/constants';

const combined = combineReducers({
  app: appReducer,
  user: userReducer,
  socket: socketReducer,
  otp: otpReducer,
  api: createReducer,
});

// The pair a 401 is reported with, in the order they are dispatched.
const sessionExpiry = [appConstants.invalidateCustomer, appConstants.setSessionExpired];

// The actions that change what the session is scoped to.
const scopeChanged = [
  userConstants.closeCustomer,
  userConstants.login,
  userConstants.logout,
  appConstants.setSessionExpired,
];

export default (state, action = {}) => {
  // A 401 that lands after the session is already gone is not an expiry to
  // report: the user is on the login page by their own doing. Both halves of it
  // are swallowed, or the invalidated customer outlives the expiry it belongs to.
  if (sessionExpiry.includes(action.type) && !state?.user?.id) {
    return state;
  }

  // The `api` slice caches responses of the current scope, and nothing reloads
  // the page any more, so the cache is dropped with the scope itself.
  if (state && scopeChanged.includes(action.type)) {
    return combined({ ...state, api: undefined }, action);
  }

  return combined(state, action);
};
